module.exports = __webpack_public_path__ + "static/img/img2.de9a137.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yxsc/img2.png
// module id = EAFu
// module chunks = 1